
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M64 45c-10.4 0-18.9 8.5-18.9 18.9s8.5 19 18.9 19S82.9 74.4 82.9 64 74.4 45 64 45z"}}),_c('path',{attrs:{"d":"M82.5 18.5c-6.6 0-12.9 1.4-18.5 4-5.6-2.6-12-4-18.5-4C20.3 18.5 0 38.8 0 64s20.3 45.5 45.5 45.5c6.6 0 12.9-1.4 18.5-4 5.6 2.6 12 4 18.5 4 25 0 45.5-20.3 45.5-45.5s-20.3-45.5-45.5-45.5zM64 105c-22.7 0-41.1-18.4-41.1-41.1S41.3 22.8 64 22.8s41.1 18.4 41.1 41.1S86.7 105 64 105z"}})])
          )
        }
      }
    